<template>
  <div class="school-info-container">
    <el-form
      ref="schoolData"
      :model="schoolData"
      :rules="rules"
      label-position="top"
      class="modern-form"
    >
      <el-row :gutter="24">
        <!-- Left Column: Main Information & Statistics -->
        <el-col :lg="16" :md="24" :sm="24" :xs="24">
          <!-- Card: General Information -->
          <div class="modern-card">
            <div class="card-header">
              <i class="el-icon-school card-header-icon"></i>
              <span class="card-title">Thông tin chung</span>
            </div>
            <div class="card-body">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Tên trường" prop="schoolName">
                    <el-input
                      v-model="schoolData.schoolName"
                      placeholder="Nhập tên trường"
                      class="modern-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Mô tả" prop="schoolDescription">
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="schoolData.schoolDescription"
                      placeholder="Nhập mô tả về trường"
                      class="modern-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Địa chỉ" prop="schoolAddress">
                    <el-input
                      v-model="schoolData.schoolAddress"
                      placeholder="Nhập địa chỉ trường"
                      class="modern-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :lg="8" :md="8" :sm="24" :xs="24">
                  <el-form-item label="Điện thoại" prop="schoolPhone">
                    <el-input
                      v-model.trim="schoolData.schoolPhone"
                      placeholder="Nhập số điện thoại"
                      class="modern-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="8" :sm="24" :xs="24">
                  <el-form-item label="Email" prop="schoolEmail">
                    <el-input
                      v-model.trim="schoolData.schoolEmail"
                      placeholder="Nhập email liên hệ"
                      class="modern-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="8" :sm="24" :xs="24">
                  <el-form-item label="Website" prop="schoolWebsite">
                    <el-input
                      v-model="schoolData.schoolWebsite"
                      placeholder="Nhập địa chỉ website"
                      class="modern-input"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- Card: System Configuration & SMS Stats -->
          <div class="modern-card system-stats-card">
            <div class="card-header">
              <i class="el-icon-setting card-header-icon"></i>
              <span class="card-title">Cấu hình & SMS</span>
            </div>
            <div class="card-body">
              <div class="stats-grid">
                <div class="stat-box">
                  <div class="stat-icon-wrapper purple">
                    <i class="el-icon-key"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-label">Mã xử lý</div>
                    <div class="stat-value">{{ schoolData.verifyCode }}</div>
                  </div>
                </div>

                <div class="stat-box">
                  <div class="stat-icon-wrapper orange">
                    <i class="el-icon-message"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-label">SMS đã dùng</div>
                    <div class="stat-value">{{ schoolData.smsUsed }}</div>
                  </div>
                </div>

                <div class="stat-box">
                  <div class="stat-icon-wrapper green">
                    <i class="el-icon-pie-chart"></i>
                  </div>
                  <div class="stat-content">
                    <div class="stat-label">SMS còn lại</div>
                    <div class="stat-value">{{ schoolData.smsTotal - schoolData.smsUsed }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <!-- Right Column: Avatar Upload & Contacts -->
        <el-col :lg="8" :md="24" :sm="24" :xs="24">
          <!-- Card: School Logo / Avatar -->
          <div class="modern-card avatar-card">
            <div class="card-header">
              <i class="el-icon-picture card-header-icon"></i>
              <span class="card-title">Ảnh đại diện trường</span>
            </div>
            <div class="card-body avatar-body">
              <div class="school-avatar-container">
                <div class="avatar-preview-box">
                  <el-image
                    v-if="schoolData.schoolAvatar != null && showPicutreInitial"
                    class="school-avatar-preview"
                    :src="schoolData.schoolAvatar"
                    fit="cover"
                  ></el-image>
                  <el-upload
                    class="school-avatar-uploader"
                    :show-file-list="true"
                    list-type="picture-card"
                    :on-change="handleChangeUpload"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :class="{ hideUpload: !showUpload, 'has-avatar': schoolData.schoolAvatar }"
                    limit="1"
                    ref="upload"
                  >
                    <div class="upload-trigger-content">
                      <i class="el-icon-camera upload-camera-icon"></i>
                      <span class="upload-text">
                        {{ schoolData.schoolAvatar != null ? 'Thay đổi ảnh' : 'Tải ảnh lên' }}
                      </span>
                    </div>
                  </el-upload>
                </div>
              </div>
              <div class="avatar-note">
                <i class="el-icon-info"></i>
                <span>Ảnh định dạng JPG/PNG. Dung lượng tối đa 5MB.</span>
              </div>
            </div>
          </div>

          <!-- Card: Contacts -->
          <div class="modern-card contacts-card">
            <div class="card-header">
              <i class="el-icon-phone card-header-icon"></i>
              <span class="card-title">Thông tin liên hệ</span>
            </div>
            <div class="card-body">
              <!-- Contact 1 -->
              <div class="contact-section">
                <div class="contact-section-title">Liên hệ chính (1)</div>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="Số điện thoại" prop="contactPhone1">
                      <el-input
                        v-model.trim="schoolData.contactPhone1"
                        placeholder="Số điện thoại 1"
                        class="modern-input"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Họ tên" prop="contactName1">
                      <el-input
                        v-model="schoolData.contactName1"
                        placeholder="Nhập tên"
                        class="modern-input"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- Contact 2 -->
              <div class="contact-section">
                <div class="contact-section-title">Liên hệ phụ (2)</div>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="Số điện thoại" prop="contactPhone2">
                      <el-input
                        v-model.trim="schoolData.contactPhone2"
                        placeholder="Số điện thoại 2"
                        class="modern-input"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Họ tên" prop="contactName2">
                      <el-input
                        v-model="schoolData.contactName2"
                        placeholder="Nhập tên"
                        class="modern-input"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- Contact 3 -->
              <div class="contact-section">
                <div class="contact-section-title">Liên hệ khác (3)</div>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item label="Số điện thoại" prop="contactPhone3">
                      <el-input
                        v-model.trim="schoolData.contactPhone3"
                        placeholder="Số điện thoại 3"
                        class="modern-input"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Họ tên" prop="contactName3">
                      <el-input
                        v-model="schoolData.contactName3"
                        placeholder="Nhập tên"
                        class="modern-input"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- Footer Button Bar -->
      <div class="form-actions-bar">
        <el-button
          v-if="checkPermission(['schoolConfig_school_update'])"
          type="success"
          size="medium"
          :loading="loadingButton"
          class="modern-btn-submit"
          @click="submitForm('schoolData')"
        >
          <i class="el-icon-circle-check" />
          <span>Lưu thông tin</span>
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import SchoolConfigService from "@/services/SchoolService/SchoolConfigService";
import {mapState} from "vuex";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      imageUrl: "",
      showUpload: true,
      showPicutreInitial: true,
      newGradeCreated: null,
      loadingButton: false,
      rules: {
        schoolName: [
          {
            required: true,
            message: "Tên trường không được để trống",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.$store.dispatch('schoolStore/fetchDataSchoolData',"plus");
  },
  computed:{
    ...mapState('schoolStore',['schoolData'])
  },
  methods: {
    checkPermission,
    getSchoolInitial() {
      this.$store.dispatch('schoolStore/fetchDataSchoolData', "plus");
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.$refs["schoolData"].resetFields();
      }, 300);
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.$refs[fromData].resetFields();
      }, 300);
    },
    resetFormData() {
      this.$refs["schoolData"].resetFields();
    },
    /**
     * click change image
     */
    handleChangeUpload(file) {
      this.beforeAvatarUpload(file);
      this.showPicutreInitial = false;
      this.showUpload = !this.showUpload;
      this.imageUrl = file.raw;
    },
    /**
     * remove image
     */
    handleRemove() {
      setTimeout(() => {
        this.showUpload = true;
        this.showPicutreInitial = true;
      }, 800);
      this.imageUrl = "";
    },
    /**
     * check image before upload
     */
    beforeAvatarUpload(file) {
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.raw.size / 1024 / 1024 <= 5;
      if (!isJPG && !isPNG) {
        this.$message.error("Bạn phải chọn định dạng ảnh");
        this.$refs.upload.clearFiles();
        throw "file not valid";
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không được quá 5MB!");
        this.$refs.upload.clearFiles();
        throw "over size";
      }
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          let inputData = this.schoolData;
          let formDatas = new FormData();
          for (var key in inputData) {
            formDatas.append(key, inputData[key]);
          }
          if (this.imageUrl != "") {
            formDatas.append("multipartFile", this.imageUrl);
          }
          SchoolConfigService.updateSchoolData(formDatas)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.getSchoolInitial();
            })
            .catch((err) => {
              let messageText =
                err.response.status == 403
                  ? this.$permissionDenied
                  : err.response.data.message;
              this.$message({
                message: messageText,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

  },

};
</script>

<style>
.hideUpload > div {
  display: none;
}
</style>
<style lang="scss" scoped>
.school-info-container {
  padding: 24px;
  background: #f8fafc;
  min-height: calc(100vh - 120px);
  box-sizing: border-box;
}

.modern-form {
  max-width: 1200px;
  margin: 0 auto;
}

.modern-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  }
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 12px;
}

.card-header-icon {
  font-size: 18px;
  color: #3b82f6;
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

/deep/ .el-form-item {
  margin-bottom: 20px;
  
  .el-form-item__label {
    font-weight: 600;
    color: #475569;
    font-size: 13px;
    padding-bottom: 6px !important;
    line-height: 1.2 !important;
  }
}

// Styling fields
.modern-input {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #334155;
    font-weight: 500;
    padding: 10px 14px;
    transition: all 0.25s ease;
    
    &:focus {
      border-color: #3b82f6;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }
  
  /deep/ .el-textarea__inner {
    font-family: inherit;
    padding: 12px 14px;
  }
}

// Stats Layout
.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.stat-box {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  transition: all 0.25s ease;
  
  &:hover {
    background: #ffffff;
    border-color: #e2e8f0;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
  }
}

.stat-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  font-size: 20px;
  
  &.purple {
    background: #f3e8ff;
    color: #a855f7;
  }
  &.orange {
    background: #ffedd5;
    color: #f97316;
  }
  &.green {
    background: #dcfce7;
    color: #22c55e;
  }
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.stat-value {
  font-size: 16px;
  color: #0f172a;
  font-weight: 700;
  margin-top: 2px;
}

// Avatar Styles
.school-avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}

.avatar-preview-box {
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.school-avatar-preview {
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

/deep/ .school-avatar-uploader {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  .el-upload--picture-card {
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: normal;
  }
  
  &.has-avatar {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    
    .el-upload--picture-card {
      background: rgba(15, 23, 42, 0.7);
      opacity: 0;
      transition: opacity 0.25s ease;
      
      &:hover {
        opacity: 1;
      }
      
      .upload-trigger-content {
        color: #ffffff;
      }
    }
  }
}

.upload-trigger-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-weight: 500;
  
  .upload-camera-icon {
    font-size: 24px;
  }
  
  .upload-text {
    font-size: 12px;
  }
}

.avatar-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  line-height: 1.4;
  color: #2563eb;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  padding: 8px 10px;
  margin-top: 16px;
  
  i {
    margin-top: 2px;
    font-size: 14px;
  }
}

// Contacts Section
.contact-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 16px;
  margin-bottom: 16px;
  
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }
}

.contact-section-title {
  font-size: 13px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 12px;
    background: #3b82f6;
    border-radius: 9999px;
  }
}

// Action Bar
.form-actions-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.02);
}

.modern-btn-submit {
  min-width: 180px;
  height: 42px;
  border-radius: 10px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>

